"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabItem = void 0;
class TabItem {
    constructor(parentId, relId, headerText) {
        this.m_parentId = parentId;
        this.m_relId = relId;
        this.m_headerText = headerText;
        this.m_isLoaded = false;
        this.m_isPropertyTab = false;
        this.m_isAllRel = false;
        this.m_isSelected = false;
        this.m_contentHtml = "";
    }
}
exports.TabItem = TabItem;
